<template>
  <section class="published-limits" aria-label="Published limits">
    <template v-if="published">
      <dl class="row no-gutters mb-2">
        <dt class="col-sm-3">Release</dt><dd class="col-sm-9">{{ published.releaseId }}</dd>
        <dt class="col-sm-3">Published at (UTC)</dt><dd class="col-sm-9">{{ publishedAt }}</dd>
        <template v-if="profileSourceId">
          <dt class="col-sm-3">Source record</dt><dd class="col-sm-9">{{ profileSourceId }}</dd>
        </template>
        <template v-if="published.calculated !== undefined">
          <dt class="col-sm-3">Calculation</dt><dd class="col-sm-9">{{ published.calculated ? 'Generated from EUR' : 'Own settings' }}</dd>
        </template>
      </dl>
      <b-form-radio-group v-model="profile" :options="profiles" buttons button-variant="outline-primary" size="sm" class="mb-3" aria-label="Published profile" />
      <LimitSettingsPreview :settings="profileSettings" :empty-text="profile === 'peak' ? 'No published peak settings' : 'No published normal settings'" />
      <template v-if="profile === 'peak' && published.schedule">
        <h6 class="mt-3">Published schedule</h6>
        <p class="mb-2">{{ published.schedule.timezone }}</p>
        <ul v-if="published.schedule.windows && published.schedule.windows.length" class="pl-3">
          <li v-for="(window, index) in published.schedule.windows" :key="index">
            {{ dayNames(window.days) }}: {{ window.start }} - {{ window.end }}
          </li>
        </ul>
        <p v-else class="text-muted">No scheduled peak windows</p>
      </template>
    </template>
    <p v-else class="text-muted mb-0">No published release</p>
  </section>
</template>

<script>
import LimitSettingsPreview from './LimitSettingsPreview.vue'

export default {
  components: { LimitSettingsPreview },
  props: { published: Object },
  data() {
    return {
      profile: 'normal',
      profiles: [{ text: 'Normal', value: 'normal' }, { text: 'Peak', value: 'peak' }]
    }
  },
  computed: {
    publishedAt() {
      const value = this.published?.publishedAt
      if (!value) return '-'
      const date = new Date(typeof value === 'number' ? value * 1000 : value)
      return Number.isNaN(date.getTime()) ? '-' : date.toISOString().replace('T', ' ').replace('.000Z', ' UTC')
    },
    profileSettings() {
      const entry = this.published?.[this.profile]
      return entry?.settings || entry || null
    },
    profileSourceId() {
      return this.published?.[this.profile]?.sourceId || this.published?.eurSourceId || null
    }
  },
  methods: {
    dayNames(days) {
      const names = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
      return (days || []).map(day => names[day - 1] || day).join(', ')
    }
  }
}
</script>

<style scoped>
.published-limits { overflow-wrap: anywhere; }
</style>
